import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { Box, Stack } from '@mui/system'
import { DBEntitySubscribersThunks, taskgroupsSelectors, tasksSelectors } from "@common-reducers/DBServiceThunks"
import { boardUserSelectOneObjectByQuery, boardsSelectors } from "@common-reducers/DBServiceThunks"
import { setExtraDataOfTaskId } from '@common-reducers/ExtraDataReducer'
import { taskActions } from '@common-reducers/TasksReducer'
import { useAppDispatch, useAppSelector } from '@common-reducers/hooks/store.hook'
import { useEffect, useMemo } from 'react'
import { CiViewList } from "react-icons/ci"
import { IoChatbubblesOutline, IoFileTrayFullOutline } from "react-icons/io5"
import EditTaskInput from '../edit-task-input/edit-task-input'
import MessageThread from './MessageThread'
import NewExtraData from './NewExtraData'
import classes from "./extraData.module.scss"
import { ExtraDataFiles } from './extraDataFiles'
import ExtraDataPanelLog from './logs/ExtraDataPanelLog'
import TaskSubscribersDialog from './task-subscribers-dialog'
import { getSelectedBoardId } from '@common-reducers/BoardsSelectors'
import PersonAvatar from '../person-avatar/person-avatar'
import { Board } from '@common-models/board'
import RowStack from '@common-components/common/row-stack/RowStack'
import { getExtraDataMergedFiles } from '@common-reducers/TaskSelectors'
import { cn } from "@/lib/utils";


export default function ExtraDataPanelChat() {
    const dispatch = useAppDispatch();
    const boardId = useAppSelector((state) => getSelectedBoardId(state))
    const displayExtraDataOfTaskById = useAppSelector(
        (state) => state.ExtraDataReducer.displayExtraDataOfTaskById
    );
    // const [currentTab, setCurrentTab] = useState(0); // Removed in favor of Shadcn Tabs state
    const isTaskModalOpen = useAppSelector((state) => state.TasksReducer.isTaskModalOpen);
    const task = useAppSelector((state) =>
        tasksSelectors.selectById(state, displayExtraDataOfTaskById)
    );
    const group = useAppSelector((state) =>
        taskgroupsSelectors.selectById(state, task?.groupId)
    );

    const user = useAppSelector((state) => boardUserSelectOneObjectByQuery(
        state.DBBoardUserReducer,
        { userId: task.createdBy }
    ))

    const currentBoardView = useAppSelector((state) => state.TasksReducer.currentBoardView)

    const selectedBoardId = useAppSelector(getSelectedBoardId);
    const board: Board = useAppSelector((state) =>
        boardsSelectors.selectById(state, selectedBoardId)
    );

    const totalFiles = useAppSelector(getExtraDataMergedFiles);
    const totalFileCount = useMemo(() => {
        if (!totalFiles) return 0;
        return [totalFiles.tasks, totalFiles.updates, totalFiles.generalFiles]
            .flat()
            .filter(Boolean)
            .length;
    }, [totalFiles]);

    // const handleTabChange = (event, newValue) => { // Removed
    //     setCurrentTab(newValue);
    // };


    useEffect(() => {
        if (!task) {
            dispatch(taskActions.setTaskViewSideDrawerOpenWith(""));
            dispatch(setExtraDataOfTaskId(""))
        }

    }, [dispatch, task])

    useEffect(() => {
        dispatch(DBEntitySubscribersThunks.find({
            $paginate: false,
            boardId,
            entityType: 'board',
            deleted: false,
        }))
        dispatch(DBEntitySubscribersThunks.find({
            $paginate: false,
            boardId,
            taskId: displayExtraDataOfTaskById,
            entityType: 'task',
            deleted: false,
        }))
    }, [])

    return (
        <Tabs defaultValue="updates" className="flex flex-col h-full min-h-0 bg-[var(--color-surface)]">

            {
                !isTaskModalOpen &&
                <Stack spacing={1} className={classes.task_name} sx={{ overflow: "hidden", padding: "0 30px 15px", background: "var(--color-surface)" }} >
                    <Stack direction="row" justifyContent={"space-between"}>
                        <Box sx={{ color: group?.colorAccent || "#00c875", fontSize: "15px", fontWeight: "600", fontFamily: "Poppins", padding: "0 5px" }}>
                            {group?.name}
                        </Box>
                        {/* <TaskSubscribersDialog />
                        {user &&
                            <RowStack>
                                <PersonAvatar textSize={10} size={24} email={user.email}

                                    profileImg={user?.profile?.profileImg}
                                    lastName={user?.profile?.lastName}
                                    firstName={user?.profile?.firstName} />
                            </RowStack>

                        } */}

                    </Stack>

                    <EditTaskInput taskId={task?._id}
                        isMultiline={true}

                        rowsMax={6}
                        boxSx={{
                            fontSize: '24px',
                            fontFamily: 'Poppins',
                            wordWrap: "break-word",
                            whiteSpace: "normal"
                        }} inputSx={{
                            fontSize: '24px',
                            fontFamily: 'Poppins',
                        }}
                    />
                </Stack>
            }


            <TabsList className="w-full justify-start bg-[var(--color-surface)] border-b border-gray-200 px-[30px] rounded-none h-auto p-0 mb-0">
                <TabsTrigger
                    value="updates"
                    className="data-[state=active]:shadow-none data-[state=active]:bg-transparent data-[state=active]:text-[#0f172a] data-[state=active]:border-b-2 data-[state=active]:border-[#FDAB3D] rounded-none bg-transparent h-[50px] px-4 font-poppins font-semibold text-[#64748b] text-[14px] flex items-center gap-2"
                >
                    <IoChatbubblesOutline className="text-lg" /> Updates
                </TabsTrigger>
                <TabsTrigger
                    value="files"
                    className="data-[state=active]:shadow-none data-[state=active]:bg-transparent data-[state=active]:text-[#0f172a] data-[state=active]:border-b-2 data-[state=active]:border-[#FDAB3D] rounded-none bg-transparent h-[50px] px-4 font-poppins font-semibold text-[#64748b] text-[14px] flex items-center gap-2 relative"
                >
                    <IoFileTrayFullOutline className="text-lg" /> Files
                    {totalFileCount > 0 && (
                        <span className="absolute -top-[2px] -right-[5px] bg-[#33A1FD] text-white text-[10px] font-bold px-1.5 py-0.5 rounded-full min-w-[18px] text-center border-2 border-[var(--color-surface)] flex items-center justify-center">
                            {totalFileCount}
                        </span>
                    )}
                </TabsTrigger>
                <TabsTrigger
                    value="logs"
                    className="data-[state=active]:shadow-none data-[state=active]:bg-transparent data-[state=active]:text-[#0f172a] data-[state=active]:border-b-2 data-[state=active]:border-[#FDAB3D] rounded-none bg-transparent h-[50px] px-4 font-poppins font-semibold text-[#64748b] text-[14px] flex items-center gap-2"
                >
                    <CiViewList className="text-lg" /> Logs
                </TabsTrigger>
            </TabsList>

            <div
                style={{
                    padding: "0 30px 24px",
                    background: "var(--color-surface)",
                    flex: 1,
                    minHeight: 0,
                    overflow: "auto",
                    boxSizing: "border-box"
                }}
                className={classes.body}
            >
                <TabsContent value="updates" className="mt-0 h-full min-h-0">
                    <NewExtraData />
                    <div className={classes.render_threads_comp}>
                        <MessageThread />
                    </div>
                </TabsContent>

                <TabsContent value="files" className="mt-0 h-full min-h-0">
                    <ExtraDataFiles />
                </TabsContent>
                <TabsContent value="logs" className="mt-0 h-full min-h-0">
                    <ExtraDataPanelLog />
                </TabsContent>
            </div>
        </Tabs>
    )
}
